import styled from 'styled-components';
import { Select } from 'components/Form/subcomponents/Select';

import selectIcon from 'assets/icons/select-dropdown.svg';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { medias } from 'assets/styled/tokens';
export const Header = styled.header`
  background-color: #1e1e1e;
  height: 64px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  @media (min-width: ${medias.desktopSm}) {
    height: 200px;
    padding: 0 10%;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
`;
export const TitleContainer = styled.div`
  height: 80%;
  width: 90%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px 11px 0 11px;
  // flex-direction: row;
  @media (min-width: ${medias.desktopSm}) {
    height: 80%;
    width: 65%;
    display: flex;
    //flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: 20px 50px 20px 0;
  }
`;
export const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  svg {
    height: 56px;
    width: 249px;
  }
  @media (min-width: ${medias.desktopSm}) {
    height: 80%;
    width: 100%;
    //flex-direction: row;
    //align-items: flex-end;
    svg {
      margin-top: 20px;
      height: 40px;
      width: 386px;
    }
  }
`;
export const CompanyLogo = styled.div`
  height: 92px;
  width: 92px;
  border-radius: 5px;
  margin-top: 40px;
  //padding: 4px;
  overflow: hidden;
  background-color: #fff;
  @media (min-width: ${medias.desktopSm}) {
    margin-left: 40px;
    margin-top: 0;
  }
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;
export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px 11px;
  width: 100%;
  @media (min-width: ${medias.desktopSm}) {
    height: 80%;
    width: 35%;
    flex-direction: row;
    justify-content: flex-end;
    padding: 20px 20px 20px 0;
  }
`;
export const StyledFormGroup = styled(FormGroup)`
  top: 84px;
`;
export const CompanySelect = styled(Select)`
  border: 1px solid #ffffff;
  height: 32px;
  width: 27%;
  border-radius: 4px;
  input {
    background: url(${selectIcon}) right 10px center / 8px 4px no-repeat, #ffffff;
    //color: #ffffff;
  }
  ul {
    margin-top: 32px;
    //background-color: #1e1e1e;
    //border: 1px solid #ffffff;
    border-radius: 0 0 4px 4px;
    section {
      li {
        &:hover {
          background-color: #1e1e1e;
        }
        label {
          color: #ffffff;
        }
      }
    }
  }
  @media (min-width: ${medias.desktopSm}) {
    width: 384px;
  }
`;
export const CompanyKnowMoreDiv = styled.div`
  width: 100%;
  position: relative;
  a {
    position: absolute;
    right: -30.5vw;
    font-family: Roboto;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #dc7d00;
    top: 120px;
    svg {
      margin-left: 5px;
    }
  }
`;
